import React from "react";
import { Link } from "zudoku/components";

export function ApiReference() {
  return (
    <div className="mx-auto max-w-5xl px-6 py-16 bg-white text-gray-900 dark:bg-black dark:text-white transition-colors duration-300">
      {/* Header */}
      <header className="mb-12 text-center max-w-2xl mx-auto">
        <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-white">
          API Reference
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400">
          Explore Vozzo’s APIs for campaign management, call intelligence, and
          programmatic calling.
        </p>
      </header>

      {/* Catalog Grid */}
      <div className="grid gap-8 sm:grid-cols-2">
        <ApiCard
          title="Call Intelligence API"
          description="Analyze calls, extract insights, and power AI-driven intelligence."
          href="/api/call-intel"
        />

        <ApiCard
          title="Campaign Management API"
          description="Create, manage, and optimize outreach campaigns at scale."
          href="/api/campaigns"
        />

        <ApiCard
          title="Agent API"
          description="Create, retrieve, and manage AI voice agents."
          href="/api/agents"
        />
      </div>
    </div>
  );
}

function ApiCard({
  title,
  description,
  href,
}: {
  title: string;
  description: string;
  href: string;
}) {
  return (
    <Link
      to={href}
      className="group flex flex-col justify-between rounded-2xl 
                 border border-gray-200 bg-white 
                 dark:border-gray-700 dark:bg-gray-900
                 p-8 shadow-sm transition-all duration-300
                 hover:shadow-lg hover:border-primary hover:bg-gray-50
                 dark:hover:bg-gray-800"
    >
      <div>
        <h2 className="mb-3 text-2xl font-semibold 
                       text-gray-900 dark:text-white
                       group-hover:text-primary transition">
          {title}
        </h2>
        <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
          {description}
        </p>
      </div>
      <div className="mt-6 text-primary font-medium group-hover:underline transition">
        Learn more →
      </div>
    </Link>
  );
}
